import { render, staticRenderFns } from "./testchart.vue?vue&type=template&id=7218fd58&scoped=true&"
import script from "./testchart.vue?vue&type=script&lang=js&"
export * from "./testchart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7218fd58",
  null
  
)

export default component.exports